import { render, staticRenderFns } from "./OrgNews.vue?vue&type=template&id=32dc8ace&scoped=true&"
import script from "./OrgNews.vue?vue&type=script&lang=js&"
export * from "./OrgNews.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./OrgNews.vue?vue&type=style&index=0&id=32dc8ace&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "32dc8ace",
  "4ba3d977"
  
)

export default component.exports